import { render, staticRenderFns } from "./CompTabelaErrosAjuizamento.vue?vue&type=template&id=2dff0e64&"
import script from "./CompTabelaErrosAjuizamento.vue?vue&type=script&lang=js&"
export * from "./CompTabelaErrosAjuizamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports